import { Css, Icon, Tooltip } from "@homebound/beam";

export function OptionInCheckoutTag(props: { showInCheckout: boolean }) {
  const { showInCheckout } = props;
  return (
    <Tooltip
      title={
        <>
          <p>Option is shown in checkout.</p>
          <br />
          <p>All options used in a base config must be checkout enabled.</p>
        </>
      }
    >
      <div css={Css.df.gap1.aic.green500.if(!showInCheckout).yellow500.$}>
        <Icon icon="openBook" /> Checkout {showInCheckout ? "Enabled" : "Disabled"}
      </div>
    </Tooltip>
  );
}
